import { dataHooks } from '@wix/data-hooks';

export const leaveChallengeModalDataHooks = dataHooks<{
  main;
}>('LeaveChallengeModal');
